import * as React from 'react';

import style from './DynamicInputField.module.css';

type DynamicInputFieldProps = {
    api: any,
    field: Field,
}

type Field = {
    name: string,
    text: string,
    type: string,
    putLabelOnTop: boolean,
    newline: boolean,
    required?: boolean,
    minimumValue?: number,
    maximumValue?: number,
    regex?: RegExp,
    validation?: Function,
    metadata?: any,
    defaultValue?: any,
    placeholder?: any
    disabled?: boolean,
    containerStyling?: React.CSSProperties,
    labelStyling?: React.CSSProperties,
    inputStyling?: React.CSSProperties,
    custom?: boolean,
    api?: any,
}

const DynamicInputField = (props: DynamicInputFieldProps) => {
    const dataStore = props.api.getDataStore(props.field);
    const [isValid, setValid] = React.useState(true);
    if (!props.field.defaultValue) {
        props.field.defaultValue = '';
    }
    const [value, setValue] = React.useState(dataStore.get(props.field.name) ? dataStore.get(props.field.name) : props.field.defaultValue);
    dataStore.put(props.field.name, value);
    const handleOnChange = (e: any) => {
        props.field.validation?.(e);
        dataStore.put(props.field.name, e.target.value);
        setValue(e.target.value);
    };

    const validationStyling = isValid ? style.valid : style.invalid;
    const inputField = props.field.type == 'label' ? <label id={style.value}>{value}</label> : <input onChange={handleOnChange} id={style.field} className={validationStyling} style={props.field.inputStyling} type={props.field.type} placeholder={props.field.placeholder} value={value} disabled={props.field.disabled}></input>

    props.field.validation = (e?: any) => {
        const currentValue = e ? e.target.value.trim() : dataStore.get(props.field.name).trim();

        if (!currentValue || currentValue.length == 0) {
            setValid(!props.field.required);
            return !props.field.required;
        }

        if (props.field.regex) {
            if (!props.field.regex.test(currentValue)) {
                setValid(false);
                return false;
            }
        }
        if (props.field.maximumValue && props.field.maximumValue > 0) {
            if (currentValue.length > props.field.maximumValue) {
                setValid(false);
                return false;
            }
        }
        if (props.field.minimumValue) {
            if (currentValue.length < props.field.minimumValue) {
                setValid(false);
                return false;
            }
        }
        setValid(true);
        return true;
    };

    return (
        <React.Fragment>
            <div id={style.container} style={props.field.containerStyling}>
                <label id={style.text} style={props.field.labelStyling}>{props.field.text}{props.field.required ? '*' : ''}</label>
                {props.field.putLabelOnTop ? <br></br> : ''}
                {inputField}
            </div>
            {props.field.newline ? <br></br> : ''}
        </React.Fragment>
    )
};

export default DynamicInputField;
export type { Field };